import { useContext } from "react"
import { BlockContext } from "app/regions/context/block-context"
import { getAncestorTree } from "../../../utils/block-traversal"

/**
 * Returns the block object for the parent section, or undefined if there's not
 * a parent section.
 *
 * @param {String} block_id
 * @returns {Object|undefined} parent section
 */
export function useParentSection(block_id) {
  const { blocks } = useContext(BlockContext)
  const ancestors = getAncestorTree(block_id, blocks)
  const possibleSection = ancestors.find(a => a.type === "section")

  return possibleSection
}
